import immutable from 'immutable';
import { PREFIX_ERROR_MESSAGE_LENGTH } from 'util/config/constant';
import { CLEAN_ERROR_CODE, SET_ERROR_CODE } from './action';

const init = () => {
  const initValue = immutable.fromJS({
    errorCodeObjects: undefined
  });

  return initValue.set('errorCodeObjects', {});
};

export default function errorReducer(state = init(), action) {
  switch (action.type) {
    case SET_ERROR_CODE: {
      const { errorCode } = action.payload;
      const prefixCode = errorCode.slice(0, PREFIX_ERROR_MESSAGE_LENGTH);

      return state.update('errorCodeObjects', (errorData) => {
        return {
          ...errorData,
          [prefixCode]: errorData?.[prefixCode] ? errorData[prefixCode] + 1 : 1,
          [errorCode]: errorData?.[errorCode] ? errorData[errorCode] + 1 : 1
        };
      });
    }

    case CLEAN_ERROR_CODE: {
      const { errorCode } = action.payload;

      return state.update('errorCodeObjects', (errorData) => {
        const cloneErrorData = { ...errorData };
        delete cloneErrorData[errorCode];

        return {
          ...cloneErrorData
        };
      });
    }

    default:
      return state;
  }
}
